import React from "react";
import { motion } from "framer-motion";

const text = "ViewGate";

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.045
    }
  }
};

const letter = {
  hidden: {
    opacity: 0,
    y: 6,
    filter: "blur(6px)"
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.25,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};

const AnimatedLogo = ({
  size = "text-2xl",
  iconSize = "w-10 h-10",
  showIcon = true
}) => {
  return (
    <div className="flex items-center gap-3">

      {/* ICONO */}
      {showIcon && (
        <motion.div
          className={`${iconSize} relative flex items-center justify-center`}
          initial={{ opacity: 0, scale: 0.9, y: 4 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        >
          <motion.img
            src="/favicon.png" // 👈 CAMBIAR POR TU LOGO
            alt="ViewGate Logo"
            className="w-full h-full object-contain scale-150"
            initial={{ filter: "blur(6px)", opacity: 0 }}
            animate={{ filter: "blur(0px)", opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.1 }}
          />

          {/* Glow tech */}
          <motion.div
            className="absolute inset-0 rounded-full bg-cyan-400/25 blur-xl"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: [0, 0.3, 0], scale: [0.8, 1.2, 0.8] }}
            transition={{
              duration: 2.5,
              delay: 0.4,
              ease: "easeInOut"
            }}
          />
        </motion.div>
      )}

      {/* TEXTO */}
      <motion.div
        className={`relative flex font-black tracking-tight ${size}`}
        variants={container}
        initial="hidden"
        animate="visible"
      >
        {text.split("").map((char, i) => (
          <motion.span
            key={i}
            variants={letter}
            className={
              char === "V" || char === "G"
                ? "text-cyan-400"
                : "text-white"
            }
          >
            {char}
          </motion.span>
        ))}

        {/* Glimmer PRO */}
        <motion.span
          className="absolute inset-0 pointer-events-none bg-gradient-to-r from-transparent via-white/50 to-transparent bg-[length:200%_100%] bg-clip-text text-transparent"
          initial={{ backgroundPosition: "100% 0%" }}
          animate={{ backgroundPosition: "-100% 0%" }}
          transition={{
            delay: 1.2,
            duration: 1.6,
            ease: "easeInOut",
            repeat: Infinity,
            repeatDelay: 4
          }}
        >
          {text}
        </motion.span>
      </motion.div>
    </div>
  );
};

export default AnimatedLogo;